module.exports = __webpack_public_path__ + "img/xiang5.733347ce.png";